module.exports = __webpack_public_path__ + "img/GAME_COLORLOTUS1.36acdd81.jpg";